import React, { useEffect, useState } from 'react';
import { Button, Descriptions, Typography, Spin, Table } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { CustomButton } from '../../../components';

import BreadcrumbContainer from '../../../containers/Breadcrumb';

import PdfViewer from '../../../components/PdfViewer';

import { contractHistoryDetail } from '../../../api/module/term_legal_validation_document';
import { get as getDocumentUrl } from '../../../api/module/document_repository';

import INTERNAL_LINKS from '../../../enums/InternalLinks';

import './style.scss';

const { Title } = Typography;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

const DocumentValidationContractualResume = ({ history, match }) => {
  const breadcrumbItems = [
    {
      text: 'Validación de Documentos Jurídico',
      to: `${INTERNAL_LINKS.DOCUMENT_VALIDATION_CONTRACTUAL}`,
    },
    {
      text: 'Validación Jurídico',
    },
  ];
  const [loading, setLoading] = useState(true);
  const [contract, setContract] = useState(null);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [showPdf, setShowPdf] = useState(false);

  const columns = [
    {
      title: 'Tipo Documento',
      dataIndex: 'nombre_plantilla',
    },
    {
      title: 'Acciones',
      dataIndex: 'id',
      key: 'id',
      render: (_, record) => {
        return (
          <Button
            type="default"
            onClick={async () => {
              const response = await getDocumentUrl(
                record.documento_firmado_nombre,
              );
              setPdfUrl(response.data.url);
              setShowPdf(true);
            }}
          >
            Visualizar
          </Button>
        );
      },
    },
  ];

  useEffect(() => {
    getContractInformation();
  }, []);

  const getContractInformation = async () => {
    try {
      const response = await contractHistoryDetail(match.params.id);
      setContract(response.data);
      setLoading(false);
    } catch (err) {
      console.log(err);
    }
  };

  const back = () => {
    history.goBack();
  };

  return (
    <>
      <BreadcrumbContainer items={breadcrumbItems} />

      <div className="box-title">
        <Title>DOCUMENTOS CONTRACTUALES</Title>
      </div>

      {loading === true ? (
        <div className="spin-container">
          <Spin indicator={antIcon}></Spin>
        </div>
      ) : (
        <>
          {contract != null && (
            <Descriptions bordered={true} column={2}>
              <Descriptions.Item label="Proyecto" span={2}>
                {contract.proyecto_nombre}
              </Descriptions.Item>
              <Descriptions.Item label="Nro. Contrato">
                {contract.numero_contrato}
              </Descriptions.Item>
              <Descriptions.Item label="Cargo">
                {contract.cargo_nombre}
              </Descriptions.Item>
            </Descriptions>
          )}
          <br></br>
          <br></br>
          <Table dataSource={contract.docs} columns={columns} rowKey="id" />

          <PdfViewer
            pdf={pdfUrl}
            onCancel={() => {
              setPdfUrl(null);
              setShowPdf(false);
            }}
            open={showPdf}
          />

          <CustomButton
            type={'default'}
            className={'back-button'}
            htmlType="button"
            onClick={() => back()}
            text="Volver"
          />
        </>
      )}
    </>
  );
};

export default DocumentValidationContractualResume;
